import React from 'react'
import { mobileNavigation } from '../contants/navigation'
import { NavLink } from 'react-router-dom'

const MobileNavigation = () => {
  return (
    <section className='lg:hidden h-14 bg-almost-black border-t border-border-color backdrop-blur-md fixed bottom-0 w-full z-40'>
        <div className='flex items-center justify-between h-full text-light-gray-2'>
            {
                mobileNavigation.map((nav,index)=>{
                    return(
                        <NavLink 
                            key={nav.label+"mobilenavigation"} 
                            to={nav.href}
                            className={({isActive})=>`px-3 flex h-full items-center flex-col justify-center transition-colors ${isActive ? "text-very-light-gray" : "text-light-gray-2 hover:text-very-light-gray"}`}
                        >
                            <div className='text-2xl'>
                                {nav.icon}
                            </div>
                            <p className='text-xs font-medium'>{nav.label}</p>
                        </NavLink>
                    )
                })
            }
        </div>
    </section>
  )
}

export default MobileNavigation
